import React, { useEffect } from 'react';

import { useApiContext } from '@internal/components/common/api-context';
import { Profile } from '@internal/types/profile';

import { useProfileStrength } from '../hooks';
import { useRoleContext } from '../roles';
import { computeJourneyEventFlags, trackJourneyEvents } from './journey-events';

const EMPTY_PROFILE = {} as Profile;

const JourneyEventsWatcher: React.FC = () => {
  const { profile } = useApiContext();
  const { roles, loading: rolesLoading } = useRoleContext();
  const { complete: profileComplete, loading: strengthLoading } =
    useProfileStrength(profile ?? EMPTY_PROFILE);

  useEffect(() => {
    const apiKey = profile?.apiKey;
    if (!profile || !apiKey || rolesLoading || strengthLoading) return;
    trackJourneyEvents(
      apiKey,
      computeJourneyEventFlags(roles, profileComplete)
    );
  }, [profile, roles, rolesLoading, strengthLoading, profileComplete]);

  return null;
};

export default JourneyEventsWatcher;
